import React from 'react'
import { AiFeaturePreset } from '../../../../../models/AiFeaturePreset'
import { PresetInputParametersHierarchyConfigModal } from '../PresetInputParametersHierarchyConfigModal'
import { GlobalPresetTemplateConfigForm } from './Hierarchy/GlobalPresetTemplateConfigForm'
import { CurrentUserPresetTemplateConfigForm } from './Hierarchy/CurrentUserPresetTemplateConfigForm'
import { TeamMemberPresetTemplateConfigForm } from './Hierarchy/TeamMemberPresetTemplateConfigForm'

export interface PresetTemplateConfigModalProps {
  show: boolean
  onHide: () => void
  preset: AiFeaturePreset
}

export const PresetTemplateConfigModal: React.FC<PresetTemplateConfigModalProps> = ({ show, onHide, preset }) => {
  return (
    <PresetInputParametersHierarchyConfigModal
      show={show}
      onHide={onHide}
      preset={preset}
      GlobalConfig={GlobalPresetTemplateConfigForm}
      CurrentUserConfig={CurrentUserPresetTemplateConfigForm}
      TeamMembersConfig={TeamMemberPresetTemplateConfigForm}
    />
  )
}
